import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'
import Layout from './views'

const PetSitterHeader = () => {
  const { template } = useTemplateContext()
  return (
    <Layout.Header backgroundColor="complementary" textColor="primary" >
      <CommonComponents.Wrapper height="80px">
        <Layout.Logo>
          {template.logo.src ? (
            <Layout.LogoImage src={template.logo.src} />
          ) : (
            <Layout.LogoText fontFamily={template.logo.fontFamily}>
              {template.logo.text}
            </Layout.LogoText>
          )}
        </Layout.Logo>
        <Layout.Navigation hasShoppingCart={template.sections.navigation.hasShoppingCart} />
      </CommonComponents.Wrapper>
    </Layout.Header>
  )
}

export default PetSitterHeader
